import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { ProjectDataLLPEvent } from '@avisoma/shared';

type LLPPart = ProjectDataLLPEvent['parts'][number];

/**
 * DR-4034: the surviving attached card's part number disagrees with this LLP row.
 * Advisory only — states the two documents disagree, not that the part is wrong.
 */
export function PartNumberDisagreementWarning({ part }: { part: LLPPart }) {
  const cardPartNumbers = part.partNumberDisagreement?.cardPartNumbers;
  if (!cardPartNumbers?.length) return null;
  const cards = cardPartNumbers.join(', ');
  const label =
    cardPartNumbers.length === 1
      ? `Card P/N ${cards} disagrees with this LLP row P/N ${part.partNumber}`
      : `Card P/Ns ${cards} disagree with this LLP row P/N ${part.partNumber}`;
  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      className="inline-flex text-amber-600 dark:text-amber-400"
    >
      <ExclamationTriangleIcon className="size-3.5 shrink-0" />
    </span>
  );
}
